type ClickLocation = 'hero' | 'floating' | 'cta' | 'exit_intent' | 'header_mobile';

declare global {
  interface Window {
    dataLayer?: Record<string, unknown>[];
    fbq?: (...args: unknown[]) => void;
    gtag?: (...args: unknown[]) => void;
  }
}

const SUPABASE_URL = import.meta.env.VITE_SUPABASE_URL;
const SUPABASE_KEY = import.meta.env.VITE_SUPABASE_PUBLISHABLE_KEY;
const SESSION_ID_KEY = 'neosdr_session_id';

export function trackWhatsAppClick(location: ClickLocation) {
  // 1. GTM dataLayer — whatsapp_click
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    event: 'whatsapp_click',
    click_location: location,
  });

  // 2. Google Ads conversion via dataLayer (robust fallback for GTM-only setups)
  window.dataLayer.push({
    event: 'ads_conversion',
    send_to: 'AW-17949985055/7z7YCPSvloIcEJ-SnO9C',
    click_location: location,
  });

  // 3. Google Ads direct gtag call (when available)
  if (typeof window.gtag === 'function') {
    window.gtag('event', 'conversion', {
      send_to: 'AW-17949985055/7z7YCPSvloIcEJ-SnO9C',
      event_callback: () => {},
    });
  }

  // 4. Meta Pixel
  if (typeof window.fbq === 'function') {
    window.fbq('track', 'Contact', { content_name: `whatsapp_${location}` });
  }

  // 3. Edge Function analytics (fire-and-forget)
  try {
    const sessionId = sessionStorage.getItem(SESSION_ID_KEY);
    if (!sessionId) {
      console.warn('[trackWhatsAppClick] No session_id yet — skipping analytics event');
      return;
    }

    fetch(`${SUPABASE_URL}/functions/v1/track-analytics`, {
      method: 'POST',
      keepalive: true,
      headers: {
        'Content-Type': 'application/json',
        apikey: SUPABASE_KEY,
        Authorization: `Bearer ${SUPABASE_KEY}`,
      },
      body: JSON.stringify({
        type: 'event',
        data: {
          session_id: sessionId,
          event_type: 'conversion',
          event_name: 'whatsapp_click',
          element_text: location,
          page_path: window.location.pathname,
          metadata: { click_location: location },
        },
      }),
    }).catch(() => {
      // silently fail
    });
  } catch {
    // silently fail
  }
}
